// export const ACTIVITY_DEFINITION_SEARCH_MODULE_URL =
//   'activity-definition-public/search';

export const ACTIVITY_DEFINITION_SEARCH_MODULE_URL =
  'v2/volunteer/activity-definition-public/search';
